import React from 'react';
import {CompetenciesByPillarSelect} from './CompetencyByPillarSelect';
import {RESOURCE_FIELD_TOOLTIPS} from '../../../utils/tooltipConstants';

export const CompetenciesByPillarWithInfoSelect = () => {
  return <CompetenciesByPillarSelect infoText={RESOURCE_FIELD_TOOLTIPS.jaCompetencies} />;
};
